import { themePalette } from '@theme/muiTheme';
import styled from 'styled-components';

export const MarqueeBoxStyled = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 6;
  pointer-events: none;
  border: 1px solid ${themePalette.system.info};
  background: ${themePalette.system.info}1a;
  border-radius: 1px;
`;
